<template>
  <div class="container">

    <div id="toggle-container">
      <button @click="selected_funnel='whatsapp'"  :class="{ selected: selected_funnel === 'whatsapp' }" id="whatsapp-funnel-btn">WhatsApp Push</button>
      <button @click="selected_funnel='link'"      :class="{ selected: selected_funnel === 'link' }" id="link-funnel-btn" >WhatsApp Link&nbsp;&nbsp;<span>🔗</span></button>
      <button @click="selected_funnel='messenger'" :class="{ selected: selected_funnel === 'messenger' }" id="messenger-funnel-btn" >Messenger Link</button>
      <div id="selected-slider" :class="{ link_selected: selected_funnel === 'link', messenger_selected: selected_funnel === 'messenger' }"></div>
    </div>

    <div id="funnel-container">

      <template v-for="(step, step_index) of funnel_steps">

        <!-- Funnel Bars -->
        <div class="step-container">
          <p class="step-title">{{ step.name }}</p>
          <p class="step-count">{{ numberWithCommas(step.count) }}</p>
          <div class="bar-outer">
            <div class="bar-inner" v-if="step.count" v-bind:style="{ height: (step.count / funnel_steps[0].count * 187)  + 'px' }"></div>
          </div>
        </div>

        <!-- Conversion Percentages -->
        <div v-if="step.name !== 'Survey Completed'" class="conversion-container">
          <div class="conversion">
            <p>{{ getConversion(step_index) }}%</p>
          </div>
        </div>

      </template>

      <!-- Total Conversion Percentage -->
      <!-- <p v-if="selected_funnel === 'whatsapp'" class="total-conversion"> -->
      <h4 class="total-conversion">
        {{ getTotalConversion() }}% Conversion
      </h4>

    </div>

  </div>
</template>

<script>

import moment from 'moment';

export default {

  name: 'Funnel',

  props: {
    whatsapp_pushes: Array
  },
  data() {
    return {
      selected_funnel: 'whatsapp'
    }
  },
  computed: {

    funnel_steps() {
      if (this.selected_funnel === 'messenger') {
        return this.messenger_step_counts;
      } else if (this.selected_funnel === 'link') {
        return this.link_step_counts;
      } else {
        return this.whatsapp_step_counts;
      };
    },

    whatsapp_step_counts() {

      let counts = [
        {
          name: 'Sent',
          count: 0
        },
        {
          name: 'Delivered',
          count: 0
        },
        {
          name: 'Read',
          count: 0
        },
        {
          name: 'Survey Started',
          count: 0
        },
        {
          name: 'Survey Completed',
          count: 0
        }
      ];

      if (!this.whatsapp_pushes) {
        return counts;
      };

      let failed_count = 0;
      let previously_opted_out_count = 0;
      //let pushes_unique_by_users = _.uniqBy(this.whatsapp_pushes, 'phone');
      for (let push of this.whatsapp_pushes) {
        if (push.time_sent) {
          counts[0].count++;
        };
        if (push.time_failed) {
          failed_count++;
        };
        if (push.time_survey_opted_out) {
          previously_opted_out_count++;
        };
        if (push.time_read) {
          counts[2].count++;
        };
        if (push.time_survey_started) {
          counts[3].count++;
        };
        if (push.time_survey_completed) {
          counts[4].count++;
        };
      };

      // Delivered pushes = Sent - Failed - Using this formula, since I don't want to also listen to delivered events
      //counts[1].count = counts[0].count - failed_count - previously_opted_out_count;
      counts[1].count = counts[0].count - failed_count;

      for (let index of [3,2,1,0]) {
        if (counts[index].count < counts[index+1].count) {
          counts[index].count = counts[index+1].count;
        };
      };

      return counts;
    },


    link_step_counts() {

      let counts = [
        {
          name: 'Clicks',
          count: 0
        },
        {
          name: 'Survey Started',
          count: 0
        },
        {
          name: 'Survey Completed',
          count: 0
        }
      ];

      let survey_index = this.$route.params.survey_index;
      let surveys = this.$store.state.surveys;

      if (!surveys) {
        return counts;
      };

      let survey = surveys[survey_index];
      if (!survey) {
        return counts;
      };


      counts[0].count = survey.link_click_count || 0;
      let total_survey_started_count = survey.started_users ? survey.started_users.length : 0;

      if (survey.started_users) {
        let whatsapp_survey_started_count = this.whatsapp_step_counts[3].count || 0;
        counts[1].count = total_survey_started_count - whatsapp_survey_started_count;
      };

      let total_survey_completed_count = survey.completed_users ? survey.completed_users.length : 0;
      if (survey.completed_users) {
        let whatsapp_survey_completed_count = this.whatsapp_step_counts[4].count || 0;
        counts[2].count = total_survey_completed_count - whatsapp_survey_completed_count;
      };

      for (let index of [1,0]) {
        if (counts[index].count < counts[index+1].count) {
          counts[index].count = counts[index+1].count;
        };
      };

      if (counts[1].count < 0) {
        counts[1].count = 0;
      };

      return counts;

    },


    messenger_step_counts() {

      let counts = [
        {
          name: 'Clicks',
          count: 0
        },
        {
          name: 'Survey Started',
          count: 0
        },
        {
          name: 'Survey Completed',
          count: 0
        }
      ];

      let survey_index = this.$route.params.survey_index;
      let surveys = this.$store.state.surveys;

      if (!surveys) {
        return counts;
      };

      let survey = surveys[survey_index];
      if (!survey) {
        return counts;
      };

      let messenger_funnel_counts = survey.messenger_funnel_counts;
      if (!messenger_funnel_counts) {
        return counts;
      };

      counts[0].count = messenger_funnel_counts.link_clicks || 0;
      counts[1].count = messenger_funnel_counts.started || 0;
      counts[2].count = messenger_funnel_counts.completed || 0;

      for (let index of [1,0]) {
        if (counts[index].count < counts[index+1].count) {
          counts[index].count = counts[index+1].count;
        };
      };

      if (counts[1].count < 0) {
        counts[1].count = 0;
      };

      return counts;

    },

  },

  methods: {

    getConversion(step_index) {

      if (this.selected_funnel === 'whatsapp') {

        let sent_count = this.whatsapp_step_counts[0].count;
        let delivered_count = this.whatsapp_step_counts[1].count;
        let read_count = this.whatsapp_step_counts[2].count;
        let survey_started_count = this.whatsapp_step_counts[3].count;
        let survey_completed_count = this.whatsapp_step_counts[4].count;

        if (step_index === 0) {
          return Math.floor(delivered_count / sent_count * 100) || '-';
        } else if (step_index === 1) {
          return Math.floor(read_count / delivered_count * 100) || '-';;
        } else if (step_index === 2) {
          return Math.floor(survey_started_count / read_count * 100) || '-';;
        } else if (step_index === 3) {
          return Math.floor(survey_completed_count / survey_started_count * 100) || '-';;
        };

      } else if (this.selected_funnel === 'link') {

        let click_count = this.link_step_counts[0].count;
        let survey_started_count = this.link_step_counts[1].count;
        let survey_completed_count = this.link_step_counts[2].count;

        if (step_index === 0) {
          return Math.floor(survey_started_count / click_count * 100) || '-';
        } else if (step_index === 1) {
          return Math.floor(survey_completed_count / survey_started_count * 100) || '-';;
        }

      } else if (this.selected_funnel === 'messenger') {

        let click_count = this.messenger_step_counts[0].count;
        let survey_started_count = this.messenger_step_counts[1].count;
        let survey_completed_count = this.messenger_step_counts[2].count;

        if (step_index === 0) {
          return Math.floor(survey_started_count / click_count * 100) || '-';
        } else if (step_index === 1) {
          return Math.floor(survey_completed_count / survey_started_count * 100) || '-';;
        };

      }

    },


    getTotalConversion() {

      if (this.selected_funnel === 'whatsapp') {

        let sent_count = this.whatsapp_step_counts[0].count;
        let survey_completed_count = this.whatsapp_step_counts[4].count;
        return Math.floor(survey_completed_count / sent_count * 100) || '-';

      } else if (this.selected_funnel === 'link') {

        let click_count = this.link_step_counts[0].count;
        let survey_completed_count = this.link_step_counts[2].count;
        return Math.floor(survey_completed_count / click_count * 100) || '-';

      } else if (this.selected_funnel === 'messenger') {

        let click_count = this.messenger_step_counts[0].count;
        let survey_completed_count = this.messenger_step_counts[2].count;
        return Math.floor(survey_completed_count / click_count * 100) || '-';

      };

    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}
</script>

<style scoped lang="scss">

.container{
  width: 100%;
  height: 350px;
  cursor: default;
}


#toggle-container{
  background-color: rgba(255,255,255,.15);
  height: 38px;
  width: 516px;
  border-radius: 25px;
  position: relative;

  button{
    background-color: transparent;
    height: 38px;
    color: rgba(255,255,255,.5);
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    padding-left: 20px;
    border: none;
    transition: all 0.2s ease;
    cursor: pointer;

    &:focus{
      outline: none;
    }
    &.selected{
      color: #146287;
      &:hover{
        color: #146287;
      }
    }
    &:hover{
      color: rgba(255,255,255,1);
    }
    background-size: 18px;
    background-position: right;
    background-repeat: no-repeat;
  }

  #whatsapp-funnel-btn{
    width: 175px;
    background-image: url("../../assets/whatsapp-logo.svg");
    background-position: 144px 10px;
  }

  #link-funnel-btn{
    width: 167px;
  }

  #messenger-funnel-btn{
    width: 160px;
    background-image: url("../../assets/icons/messenger-btn-icon.svg");
    background-position: 140px 10px;
    padding-left: 15px;
  }

  #selected-slider{
    background-color: white;
    width: 181px;
    height: 39px;
    position: absolute;
      top: 0;
      left: 0;
    border: 1px solid #117580;
    border-radius: 25px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
    z-index: -1;
    transition: all 0.1s ease;
    &.link_selected{
      width: 169px;
      left: 176px;
    }
    &.messenger_selected{
      width: 174px;
      left: 342px;
    }
  }

}

#funnel-container{
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 250px;
  margin-top: 40px;

  .step-container{
    display: flex;
    width: 97px;
    flex-direction: column;
    p{
      color: white;
    }
    .step-title{
      font-size: 13px;
      font-weight: 400;
      margin-bottom: 4px;
      white-space: nowrap;
    }
    .step-count{
      font-size: 16px;
      font-weight: 600;
    }
    .bar-outer{
      position: relative;
      height: 200px;
      background-color: rgba(255,255,255,.4);
      border-radius: 4px;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
      .bar-inner{
        position: absolute;
          bottom: 0px;
          left: 0px;
        height: 100px;
        width: 100%;
        background: rgb(255,255,255);
        background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        transition: all 0.1s ease;
      }
    }
  }

  .conversion-container{
    width: 96px;
    align-items: flex-end;
    position: relative;
    .conversion{
      position: absolute;
        left: 28px;
        top: 55%;
      padding: 5px 8px;
      background: rgb(255,255,255);
      background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      p{
        color: #14869A;
        font-size: 12px;
        font-weight: 600;
        margin: 0;
      }
    }
  }

  .total-conversion{
    font-size: 18px;
    font-weight: 600;
    color: white;
    padding-left: 28px;
    margin-top: 140px;
    margin-left: 25px;
    text-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: 0px 0px;
    background-image: url("../../assets/icons/conversion-arrow.svg");
  }

}








</style>
